function toDateTimeLocalValue(value: Date): string {
  const localValue = new Date(value.getTime() - value.getTimezoneOffset() * 60_000);
  return localValue.toISOString().slice(0, 16);
}

export function normalizeEndDateTimeForStartChange(
  startValue: string,
  endValue: string
): string {
  const normalizedStartValue = startValue.trim();
  const normalizedEndValue = endValue.trim();

  if (!normalizedStartValue || !normalizedEndValue) {
    return endValue;
  }

  const startDate = new Date(normalizedStartValue);
  const endDate = new Date(normalizedEndValue);

  if (
    !Number.isFinite(startDate.getTime()) ||
    !Number.isFinite(endDate.getTime()) ||
    endDate.getTime() >= startDate.getTime()
  ) {
    return endValue;
  }

  const normalizedEndDate = new Date(startDate);
  normalizedEndDate.setHours(22, 0, 0, 0);
  return toDateTimeLocalValue(normalizedEndDate);
}
